import { render, staticRenderFns } from "./name_lg.vue?vue&type=template&id=6d311650&"
import script from "./name_lg.vue?vue&type=script&lang=js&"
export * from "./name_lg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports